(function () {
  'use strict';

  var overlay = document.getElementById('np-overlay');
  if (!overlay) return;

  var closeBtn = document.getElementById('np-close');
  var DISMISS_KEY = 'sp_newsletter_dismissed';
  var SUBSCRIBED_KEY = 'sp_newsletter_subscribed';
  var SHOW_DELAY = 8000;

  function open() {
    overlay.classList.add('on');
    overlay.setAttribute('aria-hidden', 'false');
  }

  function close() {
    overlay.classList.remove('on');
    overlay.setAttribute('aria-hidden', 'true');
    try { localStorage.setItem(DISMISS_KEY, '1'); } catch (e) {}
  }

  closeBtn.addEventListener('click', close);
  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) close();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.classList.contains('on')) close();
  });

  var posted = overlay.getAttribute('data-posted') === 'true';

  if (posted) {
    try { localStorage.setItem(SUBSCRIBED_KEY, '1'); } catch (e) {}
    open();
    return;
  }

  var alreadyDismissed = false;
  var alreadySubscribed = false;
  try {
    alreadyDismissed = !!localStorage.getItem(DISMISS_KEY);
    alreadySubscribed = !!localStorage.getItem(SUBSCRIBED_KEY);
  } catch (e) {}

  if (alreadyDismissed || alreadySubscribed) return;

  setTimeout(function () {
    var quizRoot = document.getElementById('sp-quiz-root');
    if (quizRoot && quizRoot.classList.contains('on')) return;
    open();
  }, SHOW_DELAY);
})();
